import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    // Otros módulos de Angular que puedas necesitar
    FormsModule, // Importa FormsModule aquí
  ],
  declarations: [
    // Componentes declarados en este módulo
  ]
})
export class AuthModule { }



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  email: string = '';
  password: string = '';
  loginError: boolean = false;
  showGoogleLoginError: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  errorType: 'credentials' | 'connection' | 'server' | null = null;
  
  constructor(
    private router: Router,
    private authService: AuthService, // Inject AuthService
    private _ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
  }

  resetLoginState() {
    this.showGoogleLoginError = false;
    this.loginError = false;
    this.errorMessage = '';
    this.errorType = null;
  }

  login() {
    this.isLoading = true;
    this.resetLoginState();

    this.authService
      .login(this.email, this.password)
      .then((success) => {
        this.isLoading = false;
        if (success) {
          //recargar la página
          location.href = '/';
        }
      })
      .catch((error) => {
        this.isLoading = false;
        console.error('Error al iniciar sesión:', error);
        this.handleLoginError(error);
      });
  }

  handleLoginError(error: any) {
    this.loginError = true;
    
    // Verificar si es un error de red/conexión
    if (!error.status || error.status === 0) {
      this.errorType = 'connection';
      this.errorMessage = 'Error de conexión. Verifica tu conexión a internet o intenta más tarde.';
      return;
    }

    // Verificar el contenido del mensaje de error del servidor
    if (error.error && typeof error.error === 'string') {
      if (error.error.includes('Username or Password Invalid')) {
        this.errorType = 'credentials';
        this.errorMessage = 'Email o contraseña incorrectos. Verifica tus credenciales.';
      } else if (error.error.includes('Error validating User')) {
        this.errorType = 'server';
        this.errorMessage = 'Error interno del servidor. Intenta más tarde.';
      } else {
        this.errorType = 'server';
        this.errorMessage = 'Error del servidor: ' + error.error;
      }
    } else {
      // Error genérico
      this.errorType = 'server';
      this.errorMessage = 'Error inesperado. Intenta más tarde.';
    }
  }
}